var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 36,
    viewBox: "0 0 33 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.619 35.994c.241-.004.483-.007.718-.015l.253-.01c2.007-.078 3.767-.327 5.447-.833 3.579-.964 6.78-2.724 9.363-5.229-.09-1.723-.692-3.914-3.044-4.493-1.48-.366-4.38-1.453-4.358-1.466a85.842 85.842 0 0 0-3.411-1.346c-.391-.175-1.014-.374-1.07-.393v-2.15c1.206-1.245 1.758-2.905 2.022-4.34.391.258 1.04.125 1.754-2.327.582-1.992.228-2.66-.274-2.827 1.63-7.578-2.093-7.833-2.093-7.833s-.562-1.05-2.041-1.842c-.991-.57-2.373-1.012-4.196-.86a6.253 6.253 0 0 0-1.67.31c-.67.218-1.283.539-1.837.912-.68.42-1.325.933-1.892 1.518-.897.89-1.696 2.042-2.043 3.479-.33 1.22-.32 2.54.173 3.881-.67-.06-1.46.317-.715 2.87.542 1.866 1.048 2.388 1.431 2.419.261 1.637.93 3.572 2.5 4.912v1.893c-.706.334-4.905 2.28-8.589 3.19-2.355.58-2.955 2.77-3.047 4.493C4.119 33.895 9.803 36 16.082 36l.24-.002-.002.002c.1 0 .2-.004.299-.006",
    fill: "#FFF",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.d455107dc41a3a77e233e8fe683d34fd.svg";
export { ForwardRef as ReactComponent };